import { toState } from "../redux";

export function getConnection(state, type) {
    try {
        const connect = state['features/base/connection'].connect;
        const connection = connect[type].isConnected;
        
        return connection || false; 
    } catch {
        return false;
    }    
}

export function isConnected(stateful) {
    const { isConnected } = toState(stateful)['features/base/connection'];

    return isConnected;
}

export function isConnecting(stateful, type) {
    const state = toState(stateful)['features/base/connection'];
    return state.type?.connecting ? true : false;
}
